import cln from 'classnames';
import React from 'react';

export const renderFormGroup = (
  label,
  showErrors,
  control,
  mandatoryLabelOverride = false
) => ({ bind, getError, hasValidator, value, pushValue }) => (
  <div
    className={cln('form-group', { 'has-error': showErrors && !!getError() })}
  >
    <div className="control-label">
      {label}
      {(hasValidator('required') || mandatoryLabelOverride) && '*'}
    </div>
    {control({ bind, value, pushValue })}
  </div>
);
